import { useContext } from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';

export interface MessageUserWelcomeMessageOnlineFansMessageStats {
    welcomeMessageId: string;
    purchasesCount: number;
    purchasesTotal: number;
}

const useMessageUsersAutoWelcomeMessageOnlineUsersWelcomeMessageStats = (welcomeMessageId: string | undefined | null) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const params = useParams();
    const axios = useAxios();

    const fetchData = async (): Promise<MessageUserWelcomeMessageOnlineFansMessageStats> => {
        if (userContext.jwtToken && settingsContext.apiKey && 'userId' in params && params.userId) {
            const query: string = `${settingsContext.routes.messageUsers.base}${params.userId}/autoWelcomeMessagesOnlineUsers/sales/stats/${welcomeMessageId}`;

            return axios
                .get(query)
                .then(async response => {
                    if (response.status === 200) {
                        return response.data;
                    }

                    return {
                        welcomeMessageId: '',
                        purchasesCount: 0,
                        purchasesTotal: 0,
                    };
                })
                .catch(error => {
                    console.error(error);

                    return {
                        welcomeMessageId: '',
                        purchasesCount: 0,
                        purchasesTotal: 0,
                    };
                });
        }

        return {
            welcomeMessageId: '',
            purchasesCount: 0,
            purchasesTotal: 0,
        };
    };

    return useQuery(['messageUsersAutoWelcomeMessageOnlineUsersWelcomeMessageStats', params.userId, welcomeMessageId], () => fetchData(), {
        refetchOnWindowFocus: false,
        // Stale time 5 minutes
        staleTime: 300000,
        refetchInterval: 300000,
        enabled: userContext.jwtToken && settingsContext.apiKey && params.userId && welcomeMessageId ? true : false,
    });
};

export default useMessageUsersAutoWelcomeMessageOnlineUsersWelcomeMessageStats;
